<!--suppress ALL -->
<template>
  <div class="detailcontent" :class="{'pc': !isPhone}">
    <pcheader v-show="!isPhone" :myflags="!isPhone"></pcheader>
    <div class="topbox" v-show="isPhone">
      <img class="banner" v-if="itemdetail.image" :src="getImage(itemdetail.image)" alt="">
    </div>
    <div class="pccontainer">
      <div class="container">
        <div class="con" ref="con">
          <div class="coninfo">
            <div class="title">{{itemdetail.name}}</div>
            <div class="infordetail">
              <div class="ditem">
                <h4><i></i>活动简介</h4>
                <div class="txt" v-if="itemdetail.introduce&&itemdetail.introduce.length>0">{{moreflag ? maxSclice(itemdetail.introduce) : itemdetail.introduce}}<a class="more" v-show="moreshow" @click="moreintro">{{moreflag ? '展开': '收起'}}</a></div>
                <div class="txt" v-else>无</div>
              </div>
              <div class="ditem">
                <h4><i></i>活动须知</h4>
                <div class="txt" v-if="itemdetail.remark">{{moreflag1 ? maxSclice(itemdetail.remark) : itemdetail.remark}}<a class="more" v-show="moreshow1" @click="moreintro1">{{moreflag1 ? '展开': '收起'}}</a></div>
              </div>
              <div class="ditem">
                <h4><i class="icon-date"></i>开始时间 <span>{{itemdetail.startTime}}</span></h4>
              </div>
              <div class="ditem">
                <h4><i class="icon-date"></i>结束时间 <span>{{itemdetail.endTime}}</span></h4>
              </div>
              <div class="ditem">
                <h4><i class="icon-name"></i>参与人数 <span>{{itemdetail.totalQuantity}}</span></h4>
              </div>
              <div class="ditem">
                <h4><i></i>地点</h4>
                <div class="txt">{{itemdetail.location}}</div>
              </div>
              <div class="ditem">
                <img class="imgitem" v-for="(item, index) in imageslist" :key="index" :src="item" alt="">
              </div>
            </div>
          </div>
          <div class="additem">
            <h2 class="pubtitle">志愿者申请信息</h2>
            <ul class="personul">
              <li>
                <div class="lileft"><i class="icon-name"></i><span>姓名</span></div>
                <div class="liright">{{volunteerinfo.realName}}</div>
              </li>
              <li>
                <div class="lileft"><i class="icon-place"></i><span>身份证</span></div>
                <div class="liright">{{volunteerinfo.identityCard}}</div>
              </li>
              <li>
                <div class="lileft"><i class="icon-phone"></i><span>手机号</span></div>
                <div class="liright">{{volunteerinfo.username}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="tipfixed" v-show="isshow" :class="{no: noenroll}" @click.stop="popup(itemdetail.id)"><span>{{noenroll ? '已结束' : '报名'}}</span></div>
    <div class="tipfixed" v-show="!isshow" :class="{no: noenroll}" @click.stop="deleteactivity(itemdetail.id)"><span>取消</span></div>
  </div>
</template>

<script type="text/ecmascript-6">
import Pcheader from '@/views/common/pcheader'
export default {
  name: 'activitydetail',
  components: {
    Pcheader
  },
  data () {
    return {
      itemdetail: {},
      moreshow: false,
      moreshow1: false,
      moreflag: true,
      moreflag1: true,
      maxLength: 50,
      imageslist: [],
      noenroll: false,
      isshow: true,
      volunteerinfo: {},
      isPhone: false, // 是否是PC端/移动端
      screenWidth: 0 // 屏幕分辨率
    }
  },
  created () {
  },
  watch: {
  },
  mounted () {
    this.getDetail()
    this.getvolunteerinfo()
    if (this.getQueryStringRegExp('isenroll') === '0') {
      this.noenroll = false
      this.isshow = true
    } else if (this.getQueryStringRegExp('isenroll') === '2') {
      this.noenroll = true
      this.isshow = false
    } else {
      this.isshow = true
      this.noenroll = true
    }
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth < 768) {
      this.isPhone = true
    } else {
      this.isPhone = false
    }
    let _this = this
    window.onresize = () => {
      _this.screenResize()
    }
  },
  methods: {
    screenResize () {
      if (document.body.clientWidth < 768) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    // 获取地址栏参数
    getQueryStringRegExp (name) {
      var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
      if (reg.test(location.href)) {
        return unescape(RegExp.$2.replace(/\+/g, ' '))
      } else {
        return ''
      }
    },
    // 失焦时触发
    blurFun () {
      setTimeout(function () {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 300)
    },
    moreintro () {
      this.moreflag = !this.moreflag
    },
    moreintro1 () {
      this.moreflag1 = !this.moreflag1
    },
    maxSclice (v) {
      return v.length > this.maxLength ? v.slice(0, this.maxLength) + '... ' : v
    },
    // 获取活动详情
    getDetail () {
      this.$http({
        url: this.$http.adornUrl(`/api/volunteer/web/activity?museumCode=` + this.$cookie.get('museumCode') + `&activityId=` + this.$route.params.id),
        method: 'get'
      }).then((res) => {
        if (res) {
          if (res.data.status === 200) {
            this.itemdetail = res.data.data
            if (res.data.data.introduce.length > 50) {
              this.moreshow = true
            }
            if (res.data.data.remark.length > 50) {
              this.moreshow1 = true
            }
            let images = res.data.data.image.split(';')
            for (let j = 0; j < images.length; j++) {
              images[j] = window.SITE_CONFIG.baseUrl + '/api/volunteer/web/images/' + images[j]
            }
            this.imageslist = images
          } else {
            this.$message.error(res.data.message)
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取我的志愿者信息
    getvolunteerinfo () {
      this.$http({
        url: this.$http.adornUrl(`/api/volunteer/web/volunteer/info?museumCode=${this.$route.query.museumCode}`),
        method: 'get'
      }).then((res) => {
        if (res) {
          if (res.data.rel === true) {
            this.volunteerinfo = res.data.data
          } else {
            if (res.data.data === '暂无志愿者信息。') {
              this.$message({message: '暂无志愿者信息, 请先完善志愿者信息', type: 'warning'})
              setTimeout(() => {
                this.$router.push({
                  path: `/volunteerinfo`,
                  query: {museumCode: this.$cookie.get('museumCode')}
                })
              }, 3000)
            }
          }
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    getImage (val) {
      let imgArr = val.split(';')
      return window.SITE_CONFIG.baseUrl + '/api/volunteer/web/images/' + imgArr[0]
    },
    // 报名活动
    popup (val) {
      if (this.getQueryStringRegExp('isenroll') === '0') {
        this.noenroll = false
        let token = this.$cookie.get('token')
        if (token !== null) {
          this.$http({
            url: this.$http.adornUrl(`/api/volunteer/web/activity/add?activityId=` + val),
            method: 'put'
          }).then((res) => {
            if (res) {
              if (res.data.rel === true) {
                this.$message({message: res.data.data, type: 'success'})
              } else {
                if (res.data.data === '你的志愿者信息为空，请先补充志愿者信息。') {
                  this.$message({message: res.data.data, type: 'warning'})
                  setTimeout(() => {
                    this.$router.push({
                      path: `/volunteerinfo`,
                      query: {museumCode: this.$cookie.get('museumCode')}
                    })
                  }, 3000)
                } if (res.data.data === '请先注册成为该馆的志愿者。') {
                  this.$message({message: res.data.data, type: 'warning'})
                  setTimeout(() => {
                    this.$router.push({
                      path: `/volunteermuseum`,
                      query: {museumCode: this.$cookie.get('museumCode')}
                    })
                  }, 3000)
                } else {
                  this.$message.error(res.data.data)
                }
              }
            } else {
              this.$message.error(res.data.data)
            }
          })
        } else {
          this.$router.push({path: '/login'})
        }
      } else {
        this.noenroll = true
      }
    },
    // 取消活动
    deleteactivity (val) {
      let token = this.$cookie.get('token')
      console.log(token)
      if (token !== null) {
        this.$http({
          url: this.$http.adornUrl(`/api/volunteer/web/activity/cancel?activityId=` + val),
          method: 'put'
        }).then((res) => {
          if (res) {
            if (res.data.rel === true) {
              this.$message({message: res.data.data, type: 'success'})
              setTimeout(() => {
                this.$router.push({path: '/myvolunteeractivity', query: {}})
              }, 2000)
            } else {
              if (res.data.data === 'token为空或失效，请重新验证。') {
                this.$router.push({path: '/login'})
              } if (res.data.data === '你没有志愿者信息。') {
                this.$router.push({path: '/volunteerinfo'})
              } else {
                this.$message.error(res.data.data)
              }
            }
          } else {
            this.$message.error(res.data.data)
          }
        })
      } else {
        this.$router.push({path: '/login'})
      }
    }
  }
}
</script>

<style lang="scss">
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .detailcontent{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    overflow-y: auto;
    background: #f1f1f1;
    z-index: 22;
    padding-bottom: 80px;
    .topbox{
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      position: relative;
      overflow: hidden;
      background: #ffffff;
      .banner{
        width: 100%;
        vertical-align: top;
      }
      .title{
        position: absolute;
        width:60%;
        top: 22%;
        left: 50%;
        margin: 0 0 0 -30%;
        z-index: 2;
        img{
          width: 100%;
          vertical-align: top;
        }
        p{
          font-size: 16px;
          margin: 10px 0 0;
          text-align: center;
          color: #eee;
          letter-spacing: 3px;
          font-family: '宋体';
        }
      }
    }
    .con{
      padding: 0 20px;
      position: relative;
      z-index: 1;
      margin-top: -15px;
      .coninfo{
        background: #fff;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        padding: 16px;
        margin: 0 0 20px 0;
        .title{
          text-align: center;
          font-size: 18px;
          line-height: 24px;
          margin: 10px 0 15px;
          font-weight: bold;
        }
        .infordetail{
          .ditem{
            border-bottom: solid 1px #f1f1f1;
            margin-bottom: 15px;
            padding-bottom: 15px;
            h4{
              font-size: 16px;
              color: #000;
              i{
                display: inline-block;
                width: 16px;
                height: 16px;
                background: url(../assets/images/icon-info.png) no-repeat;
                background-size: 100% 100%;
                vertical-align: middle;
                position: relative;
                top: -2px;
                margin-right: 5px;
                &.icon-date{
                  background: url('../assets/images/icon-date.png') no-repeat;
                  background-size: 100% 100%;
                }
                &.icon-name{
                  background: url('../assets/images/icon-name.png') no-repeat;
                  background-size: 100% 100%;
                }
              }
              span{
                margin-left: 15px;
                color: #666;
              }
            }
            .txt{
              color: #555;
              font-size: 15px;
              padding: 8px 0 0px 0px;
              .more{
                color: #732eaf;
              }
            }
            .imgitem{
              width: 100%;
            }
            &:last-child{
              border-bottom: none;
            }
          }
        }
      }
    }
    .additem{
      background: #fff;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      padding: 0 16px;
      margin-bottom: 20px;
      .pubtitle{
        font-size: 18px;
        height: 46px;
        line-height: 46px;
        i{
          display: inline-block;
          float: right;
          width: 8px;
          height: 15px;
          background: url("../assets/images/icon-arrow-right.png") no-repeat;
          background-size: 100% 100%;
          position: relative;
          top: 16px;
        }
      }
      .personul{
        border-top: solid 1px #f1f1f1;
        padding: 20px 0px 30px;
        li{
          position: relative;
          line-height: 24px;
          margin-bottom: 20px;
          height: 24px;
          &:last-child{
            margin-bottom: 0;
          }
          i{
            display: inline-block;
            width: 18px;
            height: 18px;
            vertical-align: middle;
            margin-right: 10px;
            position: relative;
            top: -1px;
          }
          .lileft{
            position: absolute;
            top: 0;
            left: 0;
            width: 100px;
            i{
              background: url("../assets/images/icon-name.png") no-repeat;
              background-size: 100% 100%;
              &.icon-phone{
                background: url("../assets/images/icon-tel.png") no-repeat;
                background-size: 100% 100%;
              }
              &.icon-place{
                background: url("../assets/images/icon-place.png") no-repeat;
                background-size: 100% 100%;
              }
            }
            span{
              font-size: 16px;
              display: inline-block;
              height: 24px;
              width: 60px;
              text-align: justify;
              vertical-align: top;
              &::after {
                display: inline-block;
                width: 100%;
                content: "";
                height: 0;
              }
            }
          }
          .liright{
            margin-left: 100px;
            height: 24px;
            text-align: right;
            /*border-bottom: solid 1px #f1f1f1;*/
            color: #444;
          }
        }
      }
    }
    .tipfixed{
      height: 60px;
      position: fixed;
      bottom: 0;
      background: #fff;
      border-top: solid 1px #eee;
      left: 0;
      width: 100%;
      z-index: 100;
      padding: 10px 0 0;
      span{
        width: 60%;
        display: block;
        margin: 0 auto;
        text-align: center;
        color:#fff;
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        -webkit-border-radius: 40px;
        -moz-border-radius: 40px;
        border-radius: 40px;
        background: -webkit-linear-gradient(left, #7b0000 , #ef6161); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(right, #7b0000, #ef6161); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(right, #7b0000, #ef6161); /* Firefox 3.6 - 15 */
        background: linear-gradient(to right, #7b0000 , #ef6161); /* 标准的语法 */
        filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#7b0000, endColorstr=#ef6161);
      }
      &.no{
        span{
          background: #aaa;
        }
      }
    }
    &.pc{
      .pccontainer{
        overflow: hidden;
        overflow-y: auto;
        position: absolute;
        top: 90px;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0 0 60px;
        .con{
          margin: 20px 0 0;
          .coninfo{
            .title{
              margin-bottom: 25px;
            }
            .infordetail {
              .ditem{
                .imgitem{
                  display: block;
                  margin: 10px auto;
                  max-width: 100%;
                  width: auto;
                }
              }
            }
          }
        }
      }
      .tipfixed{
        background: none;
        border-top: none;
        span{
          width: 20%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activitydetail.vue